import WalkthroughTab from './WalkthroughTab';

export default WalkthroughTab;
